import { Component, h } from 'preact';

import get from '../utils/get';
import objectAssign from '../utils/object-assign';
import serializeQueryString from '../utils/serialize-query-string';

class LegeStream extends Component {
  constructor() {
    super();

    this.state = {
      parentHeight: null
    };

    this.onDocumentResize = this.onDocumentResize.bind(this);
  }

  componentDidMount() {
    this.getParentHeight();

    window.addEventListener('resize', this.onDocumentResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onDocumentResize, false);
  }

  getParentHeight() {
    const parentHeight = this.base.parentNode.getBoundingClientRect().height;

    this.setState({
      parentHeight
    });
  }

  onDocumentResize() {
    this.getParentHeight();
  }

  buildEmbedUrl(chamberId, shouldAutoplay) {
    const params = {
      autostart: shouldAutoplay ? 1 : 0,
      embed: 1,
      camera_id: chamberId === 'house' ? 3 : 12
    };

    return `https://tlc${chamberId}.granicus.com/mediaplayer.php?${serializeQueryString(params)}`;
  }

  render() {
    if (this.state.parentHeight) {
      const embedUrl = this.buildEmbedUrl(
        this.props.chamberId,
        this.props.shouldAutoplay
      );

      return (
        <iframe
          frameborder="0"
          scrolling="no"
          width="100%"
          height={this.state.parentHeight}
          src={embedUrl}
        />
      );
    } else {
      return null;
    }
  }
}

export default LegeStream;



// WEBPACK FOOTER //
// ./components/legestream.js